import { LanguageSwitch } from 'modules/layout/components/LanguageSwitch.tsx';
import { Suspense, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { FullPageLoadingSpinner } from 'shared/components/FullPageLoadingSpinner.tsx';
import { LogoutButton } from 'shared/components/LogoutButton.tsx';
import { AuthContext } from 'shared/contexts/AuthContext.tsx';
import { Navbar } from './components/Navbar.tsx';

export const AuthenticatedLayout = () => {
  const { isLogoutAllowed } = useContext(AuthContext);
  return (
    <main className="mx-auto grid min-h-full-device gap-6 pb-8 pt-14 sm:max-w-container sm:grid-cols-[85px_1fr] sm:px-6 sm:pb-6 sm:pt-6 xl:grid-cols-[216px_1fr] xl:gap-8">
      <div className="absolute right-6 top-16 z-50 hidden gap-4 sm:top-6 sm:flex">
        {isLogoutAllowed && <LogoutButton />}
        <LanguageSwitch />
      </div>
      <Navbar />
      <div className="hidden sm:block" />
      <div className="mt-6 h-full sm:mt-0">
        <Suspense fallback={<FullPageLoadingSpinner size={48} />}>
          <Outlet />
        </Suspense>
      </div>
    </main>
  );
};
